export default "__VITE_ASSET__DrMshKio__"